<div class="location-wrapper">
  <mat-form-field class="search-field">
    <mat-icon matSuffix>search</mat-icon>
    <input #searchInput matInput placeholder="Search location">
  </mat-form-field>

  <div class="map-container">

    <google-map height="250px" width="100%" [center]="center" [zoom]="zoom" (mapClick)="mapClicked($event)">

      <map-marker #marker="mapMarker" [position]="markerPosition" [options]="markerOptions"
        (mapDragend)="markerDragged($event)">
      </map-marker>

      <map-info-window class="info-window">
        {{ selectedAddress }}
      </map-info-window>

    </google-map>
    <button type="button" class="location_button" (click)="getCurrentLocation()" aria-label="My location">
      <mat-icon>my_location</mat-icon>
    </button>
  </div>
</div>